export default __webpack_public_path__ + "static/media/b5.1fb3841a.jpg";